import { getCustomer } from "./getCustomer"

/**
 * Retrieves user information based on the provided user ID.
 *
 * @param {{ userId: string }}
 *
 * @returns {Promise<?string>} - Returns print number or null if not found.
 */
export const getUserPrintNumber = async ({ userId }) => {
  const userData = await getCustomer({ id: userId })

  return userData?.custom?.fields?.printAdmNumber ?? null
}
